import { cn } from "@/lib/utils";
import { useId } from "react";

interface RadioButtonProps {
  options: { value: string; label: string }[];
  defaultValue?: string;
  ariaLabel?: string;
  onValueChange?: ((value: string) => void) | undefined;
  name?: string;
  srText?: string;
  className?: string;
  disabled?: boolean;
}

const RadioButton: React.FC<RadioButtonProps> = ({
  options,
  defaultValue,
  ariaLabel,
  onValueChange,
  name = "radio-group",
  srText,
  className,
  disabled,
}) => {
  const id = useId();

  return (
    <fieldset className={cn("flex flex-wrap items-center gap-7", className)}>
      <legend className="sr-only">{srText ? srText : "Radio Buttons"}</legend>
      {options.map((option, index) => (
        <label
          key={option.value}
          htmlFor={`${id}-${index}`}
          className="has-checked:text-blue-brand flex cursor-pointer items-center gap-3 transition-colors duration-200 ease-in-out has-disabled:opacity-50"
        >
          <input
            name={name}
            disabled={disabled}
            checked={defaultValue === option.value}
            onChange={(e) => onValueChange && onValueChange(e.target.value)}
            type="radio"
            value={option.value}
            id={`${id}-${index}`}
            aria-label={ariaLabel}
            className="border-ring peer checked:bg-blue-brand checked:border-blue-brand focus:ring-blue-brand/50 relative size-5 cursor-pointer appearance-none rounded-full border-2 bg-white transition-all before:absolute before:top-1/2 before:left-1/2 before:h-2 before:w-2 before:-translate-x-1/2 before:-translate-y-1/2 before:rounded-full before:bg-white before:opacity-0 before:content-[''] checked:before:opacity-100 focus:ring-2 focus:outline-none"
          />
          {option.label}
        </label>
      ))}
    </fieldset>
  );
};

export default RadioButton;
